require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-things-2020-has-taught-us.json") })
        }
      }, "path---blog-five-things-2020-has-taught-us");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-things-2020-has-taught-us!./.cache/json/blog-five-things-2020-has-taught-us.json
// module id = 824
// module chunks = 231608221292675